// Modal.js
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const ConfirmDialog = ({ isOpen, onHeaderClose, onClose, onConfirm, msgText, sTitle, sYesBtnText, sNoBtnText }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className='model-header'>
                    <div className='modal-header-leftbox'>
                        <HelpOutlineIcon style={{marginRight:'5px'}} />
                        {sTitle}
                    </div>
                    <div className='modal-header-rightbox'><CancelIcon style={{ cursor: 'pointer' }} onClick={onHeaderClose} /></div>
                </div>
                <div className='model-body'><p>{msgText}</p></div>
                <div className='model-footer'>
                    <button onClick={onConfirm} style={{ marginRight: '10px' }}>{sYesBtnText}</button>
                    <button className='notActive' onClick={onClose}>{sNoBtnText}</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
